module.exports = __webpack_public_path__ + "static/media/sideImage.af7372ca.svg";